import api from '../api/api';

export const authService = {
  async register(email, password, plan = 'free', agreedToTerms = true) {
    const response = await api.post('/api/auth/register', { email, password, plan, agreedToTerms });
    return response.data;
  },

  async login(email, password) {
    console.log('🔷 authService.login: API呼び出し開始', { email });
    try {
      const response = await api.post('/api/auth/login', { email, password });
      console.log('✅ authService.login: 成功', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ authService.login: エラー', error);
      throw error;
    }
  },

  async getProfile() {
    console.log('🔷 authService.getProfile: API呼び出し開始');
    try {
      const response = await api.get('/api/auth/profile');
      console.log('✅ authService.getProfile: 成功', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ authService.getProfile: エラー', error);
      console.error('❌ authService.getProfile: エラー詳細', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      throw error;
    }
  },

  async updatePlan(plan) {
    const response = await api.put('/api/auth/plan', { plan });
    return response.data;
  },

  async refreshToken() {
    const response = await api.post('/api/auth/refresh');
    return response.data;
  },

  async forgotPassword(email) {
    const response = await api.post('/api/auth/forgot-password', { email });
    return response.data;
  },

  async resetPassword(token, password, confirmPassword) {
    const response = await api.post(`/api/auth/reset-password/${token}`, {
      password,
      confirmPassword
    });
    return response.data;
  },

  async verifyEmail(token) {
    const response = await api.get(`/api/auth/verify-email/${token}`);
    return response.data;
  },

  async resendVerificationEmail(email) {
    const response = await api.post('/api/auth/resend-verification', { email });
    return response.data;
  },

  async deleteAccount(password, confirmDeletion, reason = '', feedback = '') {
    const response = await api.delete('/api/auth/account', {
      data: {
        password,
        confirmDeletion,
        reason,
        feedback
      }
    });
    return response.data;
  },

  async changePassword(currentPassword, newPassword, confirmPassword) {
    const response = await api.post('/api/auth/change-password', {
      currentPassword,
      newPassword,
      confirmPassword
    });
    return response.data;
  },

  async changeEmail(newEmail, currentPassword) {
    const response = await api.post('/api/auth/change-email', {
      newEmail,
      currentPassword
    });
    return response.data;
  },

  async cancelEmailChange() {
    const response = await api.post('/api/auth/cancel-email-change');
    return response.data;
  }
};
